import { render, staticRenderFns } from "./ManuscriptPreview.vue?vue&type=template&id=4cea4925&scoped=true"
import script from "./ManuscriptPreview.vue?vue&type=script&lang=js"
export * from "./ManuscriptPreview.vue?vue&type=script&lang=js"
import style0 from "./ManuscriptPreview.vue?vue&type=style&index=0&id=4cea4925&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea4925",
  null
  
)

export default component.exports